export default "__VITE_ASSET__e21d263b__"